import { instance } from 'utils/axiosConfig';

// * Login
export interface ILoginPayloadAPI {
  email: string;
  password: string;
}
export interface ILoginResponseAPI {
  data: {
    data: {
      access_token: string;
      refresh_token: string;
      expires: number;
    };
  };
}

export const tryLogin = (data: ILoginPayloadAPI) => {
  localStorage.setItem('authTokens', '');
  return instance.post('/auth/login', data);
};
